var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5688 0.874945C4.99868 0.874945 0.468858 5.40476 0.468848 10.9749C0.468843 16.5451 4.99866 21.0749 10.5688 21.0749C16.139 21.0749 20.6689 16.5451 20.6688 10.9749C20.6688 5.40476 16.139 0.874945 10.5688 0.874945ZM10.5688 2.40369C15.308 2.40369 19.1401 6.23582 19.1401 10.9749C19.1401 15.714 15.3081 19.5413 10.5688 19.5413C5.82971 19.5413 2.0025 15.7141 2.00251 10.9749C2.00252 6.23574 5.82979 2.40369 10.5688 2.40369Z",
    fill: "#606060",
    stroke: "#606060",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3383 10.2054H15.9037C16.107 10.2054 16.3021 10.2862 16.4459 10.43C16.5897 10.5738 16.6705 10.7689 16.6705 10.9722C16.6705 11.1756 16.5897 11.3707 16.4459 11.5145C16.3021 11.6583 16.107 11.7391 15.9037 11.7391H10.569H10.5687C10.3663 11.7383 10.1723 11.6576 10.0292 11.5145C9.8861 11.3713 9.80538 11.1775 9.80466 10.975L9.80466 10.9747L9.80466 4.30729C9.8029 4.20691 9.82088 4.10717 9.85757 4.01371C9.89437 3.91996 9.94929 3.83432 10.0192 3.76178C10.0891 3.68923 10.1726 3.63125 10.265 3.59102C10.3573 3.5508 10.4566 3.52911 10.5573 3.52727L11.3383 10.2054ZM11.3383 10.2054V4.30729C11.3401 4.20453 11.3212 4.10242 11.2828 4.00708C11.2442 3.91145 11.1868 3.82461 11.1139 3.7517C11.0409 3.67878 10.9541 3.62136 10.8585 3.5828C10.7629 3.54425 10.6605 3.52534 10.5574 3.52727L11.3383 10.2054Z",
    fill: "#606060",
    stroke: "#606060",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.234578efe15ce92ad774df70dcdae8bf.svg";
export { ForwardRef as ReactComponent };